<app-side-menu (sideNavMessage$)="listenerNav($event)" [language]="language" [compact]="false"></app-side-menu>
<app-nav-bar (navMessage$)="listenerNav($event)"></app-nav-bar>
<app-footer></app-footer>

@if (security.permitted('inventory', 'inventory list', 'view')) {
    <div class="content-page bg-gray text-dark">
        <div class="content p-1">
            <h5 class="px-1 text-capitalize text-dark">Inventory</h5>
            <div class="col-md-12 p-1">
                <div class="rounded">
                    <div class="list-bar">
                        <form [formGroup]="form" class="form-row">
                            <div class="form-group col">
                                <div class="input-group">
                                    <div class="input-group-append">
                                        <span class="input-group-text"><span
                                                class="mdi mdi-magnify search-icon"></span></span>
                                    </div>
                                    <input autocomplete="off" type="search" class="form-control" id="search"
                                        autofocus="true" formControlName="inquiry" />
                                </div>
                            </div>
                            <div class="form-group col">
                                <select class="form-control" name="status" id="status-filter" formControlName="status">
                                    <option value="0">All statuses</option>
                                    @for (status of statuses; track status) {
                                        <option [value]="status.id">{{status.name}}</option>
                                    }
                                </select>
                            </div>
                            <div class="form-group col">
                                <date-span [verb]="'Received'" [default]="FILTER_SPAN_KEY"
                                    (chosen)="spanned($event)"></date-span>
                            </div>
                        </form>
                        <div class="d-flex justify-content-end">
                            @if (security.permitted('inventory', 'inventory list', 'add')) {
                            <button class="btn btn-primary shadow mr-2" [disabled]="loading" title="Add Inventory"
                                (click)="createInventory()">
                                @if (!loading) {
                                <span class="dripicons-plus h4"></span>
                                }
                                @if (loading) {
                                <span class="spinner-grow spinner-grow-sm mr-1" role="status"></span>
                                }
                            </button>
                            }
                        </div>
                    </div>
                    <div id="listing" class="col-md-12 tableFixHead" (scroll)="scrolled($event)">
                        @if (vehicles) {
                        <table class="table table-sm table-hover table-striped table-responsive-sm" id="inventoryTable">
                            <thead>
                                <tr>
                                    <th scope="col"></th>
                                    <th (click)="sort('received')" class="sorted" scope="col">
                                        Received
                                        @if (sortedAsc('received')) {
                                        <span class="dripicons-chevron-up text-dark sort-icon"></span>
                                        }
                                        @if (sortedDesc('received')) {
                                        <span class="dripicons-chevron-down text-dark sort-icon"></span>
                                        }
                                    </th>
                                    <th scope="col">{{ words[language]['Stock Number'] }}</th>
                                    <th scope="col">{{ words[language]['Year'] }} {{ words[language]['Make'] }} {{
                                        words[language]['Model'] }}</th>
                                    <th scope="col">{{ words[language]['Status'] }}</th>
                                    <th scope="col" class="text-right">{{ words[language][ 'Mileage' ] }}</th>
                                    <th class="text-right" scope="col"></th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (vehicle of vehicles; track vehicle) {
                                <tr class="clickable text-dark">
                                    <td [routerLink]="['/inventory', vehicle.id]">@if (vehicle.url) {
                                        <img [src]="vehicle.url" [alt]="vehicle.model" />
                                        }
                                    </td>
                                    <td [routerLink]="['/inventory', vehicle.id]">
                                        {{vehicle.received | date:'MMM d, yy'}}
                                        @if (vehicle.days && ['purchased', 'make ready', 'quoted', 'available'].includes(vehicle.status.toLowerCase())) {
                                            <p class="subtitle"
                                                [class.text-warning]="((vehicle.days >= 60) && (vehicle.days < 90))"
                                                [class.text-danger]="vehicle.days >= 90">{{vehicle.days}} day
                                                @if (vehicle.days !== 1) {
                                                    <span>s</span>
                                                }
                                            </p>
                                        }
                                    </td>
                                    <td [routerLink]="['/inventory', vehicle.id]">
                                        {{vehicle.stock}}
                                        <p class="subtitle">{{vehicle.vin}}</p>
                                    </td>
                                    <td [routerLink]="['/inventory', vehicle.id]">
                                        <div class="flex-start">
                                            <span class="pallette"
                                                [style.backgroundColor]="vehicle.exteriorColor ? vehicle.exteriorColor.toLowerCase() : null">&nbsp;</span>
                                            <span class="pallette"
                                                [style.backgroundColor]="vehicle.interiorColor ? vehicle.interiorColor.toLowerCase() : null">&nbsp;</span>
                                            <div>
                                                {{vehicle.year}} {{vehicle.make}} {{vehicle.model}}
                                                @if (vehicle.trimLevel) {
                                                <p class="subtitle">{{vehicle.trimLevel}}</p>
                                                }
                                            </div>
                                        </div>
                                    </td>
                                    @if (!vehicle.saleId) {
                                    <td [routerLink]="['/inventory', vehicle.id]">
                                        {{vehicle.status}}
                                    </td>
                                    }
                                    @if (vehicle.saleId) {
                                    <td
                                        [routerLink]="['/', (vehicle.status === 'Quoted' ? 'quotes' : 'sales'), vehicle.saleId]">
                                        <a
                                            [routerLink]="['/', (vehicle.status === 'Quoted' ? 'quotes' : 'sales'), vehicle.saleId]">{{vehicle.status}}</a>
                                    </td>
                                    }
                                    <td [routerLink]="['/inventory', vehicle.id]" class="text-right">{{vehicle.miles |
                                        number: '1.0-0'}}</td>
                                    <!-- actions -->
                                    <td class="text-right actions">
                                        <!-- delete -->
                                        @if (security.permitted('inventory', 'inventory list', 'delete') && discardable(vehicle.status)) {
                                        <button title="Delete" class="btn btn-sm btn-link"  (click)="selectInventory(vehicle)" data-target="#deleteModal" data-toggle="modal">
                                            @if (!loading) {
                                            <span class="dripicons-trash text-danger"></span>
                                            }
                                            @if (loading) {
                                            <span class="spinner-grow spinner-grow-sm" role="status"></span>
                                            }
                                        </button>
                                        }
                                    </td>
                                </tr>
                                }
                            </tbody>
                        </table>
                        }
                    </div>
                </div>
                <p class="list-footer text-muted">{{displayed | number: '1.0-0'}} / {{records | number: '1.0-0'}}
                    {{words[language]['displayed']}}</p>
            </div>
        </div>
    </div>
}
<!-- </div> -->

<!-- loading -->
@if (loading ) {
<div class="content-page bg-gray d-flex justify-content-center align-items-center">
    <div class="spinner-grow avatar-lg text-secondary" role="status"></div>
</div>
}

<!-- modals -->
<!-- delete modal -->
<div class="modal fade" id="deleteModal" data-backdrop="static" tabindex="-1" role="dialog"
    aria-labelledby="mySmallModalLabel">
    <div class="modal-dialog modal-sm modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body d-flex flex-wrap align-items-center justify-content-center">
                <span class="uil-trash-alt text-danger display-1"></span>
                <h3 class="text-danger w-100 text-center">{{words[language][ 'delete' ] }}</h3>
                <span class="text-dark my-1 text-center">{{words[language][ 'deleteVehicle' ] }}</span>
                <button class="btn btn-danger mt-2" (click)="deleteInventory()" [disabled]="loading">
                    @if (loading) {
                    <span class="spinner-grow spinner-grow-sm mr-1" role="status"></span>
                    }
                    {{words[language][ 'yes' ] }}</button>
                <button class="btn btn-secondary mt-2 ml-2" data-dismiss="modal" id="btn-close-modal-delete">No</button>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div><!-- /.modal -->

<!-- table edit modal -->
<div class="modal fade" id="scanVIN" data-backdrop="static" tabindex="-1" role="dialog"
    aria-labelledby="mySmallModalLabel">
    <div class="modal-dialog modal-full-width">
        <div class="modal-content">
            <inventory-scan [language]="language" [inventoryId]="selectedInventory ? selectedInventory.id : 0"
                [calledFrom]="'inventoryList'" [inventorySetupData]="inventorySetup" [lotId]="this.lotSelected"
                (emitterInformation$)="listenerChildrens($event)"></inventory-scan>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div><!-- /.modal -->

<!-- warning modal not setup -->
<button type="button" class="btn btn-warning d-none" data-toggle="modal" data-target="#alertModalSetup"
    id="btn-alertModalSetup"></button>
<div id="alertModalSetup" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-sm">
        <div class="modal-content">
            <div class="modal-body p-4">
                <div class="text-center">
                    <span class="dripicons-warning h1 text-warning"></span>
                    <p>{{words[language]['stockNull']}}</p>
                    <p class="mt-3">{{isAdmin ? words[language]['errorAdmin']:words[language]['errorNotAdmin']}}</p>
                    <button type="button" class="btn btn-warning my-2" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div><!-- /.modal -->


<button type="button" class="btn btn-warning d-none" data-toggle="modal" data-target="#showInventorySetup" data-backdrop="static" tabindex="-1" id="btn-showInventorySetup"></button>
<div id="showInventorySetup" class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-full-width">
        <div class="modal-content">
            <div class="modal-header text-dark">Complete the Inventory Setup to Begin Adding Vehicles to Inventory</div>
            <div class="modal-body p-0">
                <inventory-setup [calledFromInventoryList]="true" [entityType]="'lot'" [entityId]="lotSelected"
                    [inventorySetupData]="inventorySetup" (childEmitter$)="listenerChildrens($event)"></inventory-setup>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-link btn-sm" data-dismiss="modal"
                    id="btn-showInventorySetup-close"><span class="text-danger small">cancel</span></button>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div><!-- /.modal -->
